module.exports = __webpack_public_path__ + "img/xm_bg.a63ba262.jpg";